import { withModalProvider } from "../../hoc/withModalProvider";
import { AddAdminNotificationButton as View, IProps } from "./AddAdminNotificationButton";

export const AddAdminNotificationButton = withModalProvider<IProps>(View);
